<template lang="pug">
  v-menu(
  :close-on-content-click="true"
  v-model="notificationObj.menu"
  :disabled="notificationItems.length === 0"
  content-class="notification-menu")
    v-btn(icon dark slot="activator")
      v-badge(overlap color="achYellow2" :value="notificationItems.length !== 0")
        span(slot="badge") {{notificationItems.length}}
        v-icon(color="grey darken-1") notifications_none
    v-card
      v-list.pb-0(two-line)
        v-list-tile(
        @click="clickNotification(item)"
        v-for="(item, index) in notificationItems"
        :key="'msg' + index"
        :style="{'opacity': (item.checked) ? '0.5' : '1'}"
        v-if="index < 5")
          v-list-tile-action.mb-2.mr-2
            v-chip(label style="height: 26px" :color="item.color") {{item.category}}
          v-list-tile-content
            v-list-tile-title {{item.title}}
            v-list-tile-sub-title {{item.createTime}}
        v-list-tile.last-list(@click="$router.push('/notifications')" v-if="notificationItems.length >= 5")
          v-list-tile-content
            v-list-tile-sub-title
              v-layout(align-center justify-center)
                v-icon.mr-1 more_horiz
                span 查看全部
</template>

<script>
import { global } from 'mixins/global'

export default {
  mixins: [global],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      notificationObj: {
        menu: false
      }
    }
  },
  computed: {
    notificationItems () {
      return this.allNotifications.filter(item => item.read !== true)
    }
  },
  methods: {
    clickNotification (item) {
      let params = {
        userId: this.storeInfo.user.id,
        notificationIds: [item.id]
      }
      this.$store.dispatch('setNotificationRead', {params: params})
      this.$router.push('/notifications')
    }
  },
  watch: {
    'notificationObj.menu' (value) {
      this.$emit('update:show', value)
    },
    '$route' () {
      this.notificationObj.menu = false
      this.$emit('update:show', this.notificationObj.menu)
    }
  }
}
</script>

<style lang="sass" scoped>
  .notification-menu
    box-shadow: 0px 0px 20px 3px #d8d8d8
    position: fixed
    max-width: 300px
    top: 60px !important
    overflow: unset
    .v-card
      box-shadow: none
    .last-list
      border-top: 1px solid #e6e6e6

  .notification-menu /deep/
    .v-list__tile--link:hover
      background: #f4f4f4
    .v-list__tile
      height: 60px !important
    .last-list .v-list__tile
      height: 40px !important
    .v-list__tile__title
      font-size: 14px
    .v-list__tile__sub-title
      font-size: 12px
</style>
